import { traverseArticle } from './dom'
import CardDelegate from './CardDelegate'
import BaseDelegate from './BaseDelegate'
import PreproccessDelegate from './PreproccessDelegate'

class Article {
  constructor (
    link_data, 
    delegates = {},
    options = {}
) {
    this.origin_data = link_data
    this.initDelegates(delegates)
    this.options = options
    this.content = this.traverseArticle(Article.formatContent(this.origin_data))
    this.card_delegate.triggerCardDataRequest()
  }

  traverseArticle = traverseArticle

  // 初始化代理
  initDelegates (delegates) {
    this.setDelegate(
      'card', 
      delegates.card_delegate || new CardDelegate([])
    )
    
    this.setDelegate(
      'base', 
      delegates.base_delegate || new BaseDelegate([])
    )

    this.setDelegate(
      'preproccess', 
      delegates.preproccess_delegate || new PreproccessDelegate([])
    )
  } 

  setDelegate (type, delegate) {
    switch (type) {
      case 'base': {
        this.base_delegate = delegate.setArticle(this)
        break
      }
      case 'card': {
        this.card_delegate = delegate.setArticle(this).initCards()
        break
      }
      case 'preproccess': {
        this.preproccess_delegate = delegate.setArticle(this)
        break
      }
    }
  }



  // 格式化帖子（统一新老帖子）
  static formatContent (link_data) {
    let post_type = Article.getLinkType(link_data)
    let output  = ''
    switch (post_type) {
      case 'new': {
        output =  link_data.content[0].text
        break
      }
      case 'old': {
        let img_num = 0
        output =  link_data.content.reduce((pre, cur) => {
          switch (cur.type) {
            case 'text': {
              return pre += cur.text.split('\n').reduce((pre, cur, index) => {
                return pre += `<p>${cur}</p>`
              }, '')
            }
            case 'url': {
              return pre += `<a href="${cur.text}">${cur.text}</a>`
            }
            case 'img': {
              if (img_num < 3) {
                return pre += `<img src="${cur.url}" data-original="${cur.url}"  data-height="${cur.height}" data-width="${cur.width}">`
              } else {
                return pre += `<img src="https://cdn.max-c.com/heybox/dailynews/img/8852ab726f691652841cc27df2f864e6.jpg" data-height="${cur.height}" data-width="${cur.width}" ${this.currentLazyLoadAttr}="${cur.url}" class="lazy">`
              }
            }
            case 'game': {
              return pre += `<img data-gameid="${cur?.app_info?.steam_appid}">`
            }
            default: {
              return pre
            }
          }
        }, '')
        break
      }
    }
    output = output.replace(/http\:\/\//g, 'https://')
    return output
  }


  // 判断帖子类型
  static getLinkType (link_data) {
    if (link_data.content[0]) {
      if (link_data.content[0].type == 'html') {
        return 'new'
      } else {
        return 'old'
      }
    } else {
      throw new TypeError("帖子内容为空")
    }
  }

  // 处理帖子卡片 
  handleCustomeCard (node) {
    return Object.values(this.cards).reduce((pre,cur) => {
      return cur.addCards(pre)
    }, node)
  }

  // 触发卡片请求
  triggerCardDataRequest () {
    this.requests = {}
    Object.values(this.cards).forEach(cards => cards.request())
  }

}



export default Article